var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "loading-container", class: { show: _vm.visible } },
    [
      _c(
        "svg",
        {
          ref: "loadingbgcontainer",
          attrs: {
            height: "100%",
            id: "bg",
            viewBox: "0 0 200 200",
            width: "100%",
            xmlns: "http://www.w3.org/2000/svg",
          },
        },
        [
          _c("circle", {
            ref: "loadingbg2",
            attrs: {
              cx: "100",
              cy: "100",
              fill: "#FFCB05",
              id: "loadingbg2",
              r: "300",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "loading-content" }, [
        _c(
          "svg",
          {
            staticStyle: { opacity: "1" },
            attrs: {
              "data-name": "logo",
              height: "1000",
              viewBox: "0 0 100 100",
              width: "1000",
              xmlns: "http://www.w3.org/2000/svg",
            },
          },
          [
            _c("circle", {
              ref: "loadingbg",
              attrs: {
                cx: "50",
                cy: "50",
                fill: "var(--colors-gray-900)",
                id: "loadingbg",
                r: "22",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _vm.theme == "default"
          ? _c(
              "svg",
              {
                staticStyle: { opacity: "0" },
                attrs: {
                  "data-name": "logo",
                  height: "320",
                  id: "logo",
                  viewBox: "0 0 266.33 266.33",
                  width: "320",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M64.84,205.92v-.13c3.21-1.2,6.25-5.06,6.25-10.13A10.49,10.49,0,0,0,65.65,186a18.35,18.35,0,0,0-8-1.93H44.5v0a4,4,0,0,0,0,8H54.7c2.16,0,3.28.13,4.45.93a4.64,4.64,0,0,1,2.1,4.26,5,5,0,0,1-2.1,4.4c-1.18.87-2.47,1-4.7,1H44.94a4.57,4.57,0,0,0-4.57,4.62l.23,21.41A1.35,1.35,0,0,0,42,230H58c4.39,0,8.22-.87,10.95-3s4.7-5.13,4.7-10.19C73.69,211.18,70.16,207.32,64.84,205.92Zm-3.46,14.66c-1.48,1.13-3.15,1.27-5.32,1.27H51.91a1.35,1.35,0,0,1-1.35-1.35v-9a1.35,1.35,0,0,1,1.35-1.35h4.15c2.16,0,3.83.13,5.32,1.27a6,6,0,0,1,0,9.19Z",
                    fill: "#FFFFFF",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M93.17,196.59c-9,0-16.45,6.2-16.45,17.06S83.58,230.77,93,230.77a21.38,21.38,0,0,0,11-2.67,3.65,3.65,0,1,0-3.17-6.56A15.23,15.23,0,0,1,94.4,223c-3.65,0-6.73-1.75-7.6-5.61a1,1,0,0,1,1-1.25h19.55a1,1,0,0,0,1-1c0-.7.07-1.69.07-2.57C108.44,203.05,102.2,196.59,93.17,196.59Zm4.93,13.52H87.82a1,1,0,0,1-1-1.19,6.2,6.2,0,0,1,12.29,0A1,1,0,0,1,98.1,210.11Z",
                    fill: "#FFFFFF",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M127.45,196.59c-9,0-16.45,6.2-16.45,17.06s6.87,17.12,16.26,17.12a21.38,21.38,0,0,0,11-2.67,3.65,3.65,0,1,0-3.17-6.56,15.23,15.23,0,0,1-6.36,1.5c-3.65,0-6.73-1.75-7.6-5.61a1,1,0,0,1,1-1.25h19.55a1,1,0,0,0,1-1c0-.7.07-1.69.07-2.57C142.73,203.05,136.48,196.59,127.45,196.59Zm4.93,13.52H122.11a1,1,0,0,1-1-1.19,6.2,6.2,0,0,1,12.29,0A1,1,0,0,1,132.38,210.11Z",
                    fill: "#FFFFFF",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M167.26,196.59a12.23,12.23,0,0,0-10.14,4.8H157l0-3.12a1.06,1.06,0,0,0-1.06-1.08h-3.77a4.56,4.56,0,0,0-4.56,4.56V238.6a1.07,1.07,0,0,0,0,.21,4.94,4.94,0,0,0,9.85,0,1.07,1.07,0,0,0,0-.21v-9.77a1.06,1.06,0,0,1,1.76-.8,11.29,11.29,0,0,0,7.89,2.74c8.84,0,14.41-7.46,14.41-17.12S176,196.59,167.26,196.59ZM164.35,222c-4.21,0-7.11-3.46-7.11-8.53s2.91-8.53,7.11-8.53,7.17,3.46,7.17,8.53S168.62,222,164.35,222Z",
                    fill: "#FFFFFF",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M196.39,198.43a1.23,1.23,0,0,0-1.23-1.23h-3.61a5,5,0,0,0-5,5v22.65a1.22,1.22,0,0,0,0,.17v0a4.95,4.95,0,1,0,9.9,0c0-.1,0-.2,0-.3Z",
                    fill: "#FFFFFF",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M191.44,182.33a5.29,5.29,0,0,0-5.47,4.09,5.82,5.82,0,0,0,6.84,6.83,5.19,5.19,0,0,0,4.25-5.4A5.32,5.32,0,0,0,191.44,182.33Z",
                    fill: "#FFFFFF",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M228.42,221.57H215.76a1.06,1.06,0,0,1-.81-1.73l12.65-15.29a4.94,4.94,0,0,0,1.13-3.15h0a4.15,4.15,0,0,0-4.15-4.15H206.26a4.8,4.8,0,0,0-4.8,4.8v2.2a1.06,1.06,0,0,0,1.06,1.06h11.42a1.06,1.06,0,0,1,.81,1.73l-12,14.51a7.53,7.53,0,0,0-1.95,5.39,3.08,3.08,0,0,0,3.08,3.09h20.73a4.89,4.89,0,0,0,4.89-4.89v-2.52A1.06,1.06,0,0,0,228.42,221.57Z",
                    fill: "#FFFFFF",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  staticStyle: { opacity: "0" },
                  attrs: {
                    d: "M121.19,65.55A4.41,4.41,0,0,1,119,57.33a29,29,0,0,1,15.49-3.86,28.64,28.64,0,0,1,13.34,3.86A4.41,4.41,0,1,1,143.39,65a19.81,19.81,0,0,0-9.22-2.67A20.05,20.05,0,0,0,123.4,65,4.39,4.39,0,0,1,121.19,65.55Z",
                    fill: "#FFCB05",
                    id: "yellow-1",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  staticStyle: { opacity: "0" },
                  attrs: {
                    d: "M115.15,52.54a4.41,4.41,0,0,1-2.27-8.19,40.2,40.2,0,0,1,22.07-5.68A39.76,39.76,0,0,1,154,44.35a4.41,4.41,0,0,1-4.54,7.55,30.92,30.92,0,0,0-14.83-4.42,31.39,31.39,0,0,0-17.23,4.43A4.39,4.39,0,0,1,115.15,52.54Z",
                    fill: "#FFCB05",
                    id: "yellow-2",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  staticStyle: { opacity: "0" },
                  attrs: {
                    d: "M108.78,38.53a4.41,4.41,0,0,1-2.27-8.19,52.38,52.38,0,0,1,54,0A4.41,4.41,0,1,1,156,37.89a43.34,43.34,0,0,0-20.78-6.19A43.88,43.88,0,0,0,111,37.9,4.39,4.39,0,0,1,108.78,38.53Z",
                    fill: "#FFCB05",
                    id: "yellow-3",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M136.77,112.93l.42-.09c5.71-1.34,9.59-6.66,10.15-13a18.52,18.52,0,0,0-.54-6.27c-2.11-8.12-9.47-13.56-16.52-12.19-7.69,1.49-12.27,10.1-10.19,18.94C122.09,108.81,129.5,114.36,136.77,112.93Z",
                    fill: "#FFFFFF",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M161.76,65.92a6.31,6.31,0,1,0-9.78,8h0a26.44,26.44,0,0,1,7.79,18.77h0c0,11.39-7.16,21.82-18,25.21a26.56,26.56,0,0,1-27.82-43.36,6.31,6.31,0,1,0-8.45-9.37h0l0,0c-.13.12-.25.25-.36.38a39,39,0,0,0-11,27.13c0,37.73,37.42,48.77,39.27,72.87a1.43,1.43,0,0,0,2.64.62c14.5-23.46,36.18-43.83,36.31-73.49A39,39,0,0,0,161.76,65.92Z",
                    fill: "#FFFFFF",
                  },
                }),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.theme == "sfr"
          ? _c(
              "svg",
              {
                attrs: {
                  width: "500",
                  height: "500",
                  id: "logo",
                  "data-name": "logo",
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  viewBox: "0 0 500 500",
                },
              },
              [
                _c("image", {
                  attrs: {
                    height: "237",
                    transform: "translate(210.24 181.92) scale(0.24)",
                    width: "249",
                    "xlink:href":
                      "data:image/png;base64,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",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    fill: "#fff",
                    d: "M283.72,142.35v94.21h-7.94V163.7h-70v91.84a5.85,5.85,0,0,0,6.08,5.57H225.3v7.94H211.84a13.79,13.79,0,0,1-14-13.51V127.6h7.94v27.34h70V142.35a5.85,5.85,0,0,0-6.07-5.57h-54v-7.94h54A13.79,13.79,0,0,1,283.72,142.35Z",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    fill: "#fff",
                    d: "M293.51,293.06l-33.66,8.73a3.57,3.57,0,0,1-2.91-.51c-10.88-7.42-24.05-20.81-35.23-35.82-2.39-3.18-3.52-6-3.55-9a1.08,1.08,0,0,1,0-.18,12.41,12.41,0,0,1,8.68-10.55,9,9,0,0,1,2.36-.29c3.11,0,5.93,1.79,7.91,3.46l-7.94-30.7a11.3,11.3,0,0,1,8.11-13.77h0A11.31,11.31,0,0,1,251,212.51l4.88,18.82a10.64,10.64,0,0,1,9.49-.08,9.27,9.27,0,0,1,2,1.27,9.07,9.07,0,0,1,3.36-1.68,9.58,9.58,0,0,1,5.91.18,8.87,8.87,0,0,1,3.66,2.43,10.3,10.3,0,0,1,3.39-1c5.2-.7,10,2,13.2,7.45,2.45,4.19,4,9.82,4.87,17.23a72.93,72.93,0,0,1-.6,19.41c-1.1,6.64-3,11.72-5.61,15.09A3.51,3.51,0,0,1,293.51,293.06Zm-.9-3.48h0Zm-33,4.88,30.8-8c1.24-1.89,2.71-5.25,3.69-11.16a65.37,65.37,0,0,0,.54-17.45c-.71-6.39-2-11.1-3.92-14.4-1.2-2-3.22-4.38-6.09-4h0A4.46,4.46,0,0,0,282.1,241a3.54,3.54,0,0,1-3.53,1.3,3.58,3.58,0,0,1-2.73-2.62,3.05,3.05,0,0,0-1.49-1.85,2.68,2.68,0,0,0-1.77,0,2.22,2.22,0,0,0-1.54,1.77,3.44,3.44,0,0,1-3.19,3.11,3.65,3.65,0,0,1-3.76-2.65,4.19,4.19,0,0,0-1.69-2.24,3.7,3.7,0,0,0-2.24-.37,3,3,0,0,0-2.48,2.23,3.43,3.43,0,0,1-3.31,3,3.64,3.64,0,0,1-3.64-2.79l-6.59-25.4a4.15,4.15,0,0,0-5.07-3h0a4.16,4.16,0,0,0-3,5.06l11.61,44.86a3.58,3.58,0,0,1-6.16,3.24L234,255.85c-1.85-2.08-3.92-3.23-4.9-3.24a1.58,1.58,0,0,0-.48.06,4.73,4.73,0,0,0-1.94,1.31,4.42,4.42,0,0,0-1.39,2.52c0,.92.34,2.29,2.13,4.68C237.72,275,249.65,287.29,259.65,294.46Z",
                  },
                }),
                _vm._v(" "),
                _c("g", { attrs: { opacity: "0.75" } }, [
                  _c("path", {
                    attrs: {
                      fill: "#fff",
                      d: "M319.44,382.42v-2.08a3.09,3.09,0,0,0,1.15.22c1.41,0,2.68-.73,2.68-3a2.44,2.44,0,0,0-2.72-2.7,4.76,4.76,0,0,0-2,.41v7.13Zm0-6.6a4.29,4.29,0,0,1,1.17-.16c1.26,0,1.75.86,1.75,1.95,0,1.44-.65,2.16-1.9,2.16a3.16,3.16,0,0,1-1-.19v-3.76Zm7-.94a2.54,2.54,0,0,0-2.55,2.81c0,1.45.76,2.87,2.55,2.87s2.56-1.42,2.56-2.87a2.53,2.53,0,0,0-2.56-2.81Zm0,4.9c-1.29,0-1.62-1.22-1.62-2.09s.33-2,1.62-2,1.64,1.23,1.64,2-.32,2.09-1.64,2.09Zm7-4.79h-.82l-1.34,4.16L330.11,375h-.9l1.61,5.44h.87l1.35-4.07,1.37,4.07h.85L336.9,375H336l-1.2,4.16L333.46,375Zm6,3.13c1.32,0,2.17-.34,2.17-1.6,0-1-.8-1.64-2.08-1.64-1.71,0-2.48,1.34-2.48,2.83,0,1.79.93,2.85,2.63,2.85a4.09,4.09,0,0,0,1.81-.4l-.12-.79a3.77,3.77,0,0,1-1.6.38A1.63,1.63,0,0,1,338,378a8.25,8.25,0,0,0,1.47.12Zm.09-2.51c.85,0,1.25.38,1.25.9s-.38.85-1.41.85a6.35,6.35,0,0,1-1.4-.13c.07-1,.6-1.62,1.56-1.62Zm4,4.82v-3.71a1.83,1.83,0,0,1,1.65-.93,1.17,1.17,0,0,1,.41.07l.12-.89a1.4,1.4,0,0,0-.49-.08,2,2,0,0,0-1.72,1V375h-.86v5.44Zm4.72-2.31c1.31,0,2.17-.34,2.17-1.6,0-1-.8-1.64-2.09-1.64-1.71,0-2.48,1.34-2.48,2.83,0,1.79.93,2.85,2.64,2.85a4.19,4.19,0,0,0,1.81-.4l-.12-.79a3.82,3.82,0,0,1-1.61.38,1.64,1.64,0,0,1-1.8-1.75,8.37,8.37,0,0,0,1.48.12Zm.08-2.51c.86,0,1.26.38,1.26.9s-.39.85-1.41.85a6.38,6.38,0,0,1-1.41-.13c.07-1,.61-1.62,1.56-1.62Zm6.53-2.76v2.24a3.18,3.18,0,0,0-1.17-.21c-1.4,0-2.67.66-2.67,3a2.44,2.44,0,0,0,2.72,2.71,4.83,4.83,0,0,0,2-.42v-7.29Zm0,6.76a4.92,4.92,0,0,1-1.18.16c-1.27,0-1.75-.87-1.75-1.95,0-1.44.64-2.16,1.91-2.16a3,3,0,0,1,1,.19v3.76Zm5.05-6.76v7.29a4.87,4.87,0,0,0,2,.42,2.5,2.5,0,0,0,2.71-2.75c0-2.31-1.25-2.93-2.6-2.93a3.37,3.37,0,0,0-1.23.22v-2.25Zm.89,3a3.48,3.48,0,0,1,1-.2c1.23,0,1.89.67,1.89,2.12,0,1.05-.47,2-1.75,2a4.94,4.94,0,0,1-1.17-.17v-3.74Zm4.9,5.9a1.44,1.44,0,0,1-.62-.13l-.11.74a2.43,2.43,0,0,0,.88.18c1,0,1.55-.48,2-1.58l2.18-6h-.91l-1.56,4.42-1.7-4.42h-1l2.19,5.51c-.29.83-.61,1.26-1.34,1.26Z",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("g", { attrs: { opacity: "0.75" } }, [
                  _c("path", {
                    attrs: {
                      fill: "#fff",
                      d: "M333.47,398a1.78,1.78,0,0,1-1.15.27h-.91a.3.3,0,0,1-.3-.29v-2a.3.3,0,0,1,.3-.3h.91a1.72,1.72,0,0,1,1.15.28,1.33,1.33,0,0,1,0,2Zm.76-3.23v0a2.37,2.37,0,0,0,1.35-2.23,2.33,2.33,0,0,0-1.18-2.13,3.93,3.93,0,0,0-1.73-.42H329.8a.88.88,0,0,0,0,1.76H332a1.6,1.6,0,0,1,1,.2,1,1,0,0,1,.46.94,1.11,1.11,0,0,1-.46,1,1.58,1.58,0,0,1-1,.22h-2.08a1,1,0,0,0-1,1l.05,4.71a.31.31,0,0,0,.29.3h3.51a3.79,3.79,0,0,0,2.38-.66,2.65,2.65,0,0,0,1-2.25,2.4,2.4,0,0,0-1.92-2.4Z",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("g", { attrs: { opacity: "0.75" } }, [
                  _c("path", {
                    attrs: {
                      fill: "#fff",
                      d: "M341.46,395.68h-2.23a.22.22,0,0,1-.22-.26,1.34,1.34,0,0,1,2.67,0,.22.22,0,0,1-.22.25Zm-1.07-3a3.49,3.49,0,0,0-3.58,3.76,3.43,3.43,0,0,0,3.54,3.77,4.55,4.55,0,0,0,2.38-.59.81.81,0,0,0,.48-.74.79.79,0,0,0-.8-.79.72.72,0,0,0-.37.09,3.3,3.3,0,0,1-1.38.33,1.55,1.55,0,0,1-1.65-1.24.22.22,0,0,1,.21-.28h4.26a.22.22,0,0,0,.22-.21c0-.15,0-.36,0-.56a3.27,3.27,0,0,0-3.33-3.54Z",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("g", { attrs: { opacity: "0.75" } }, [
                  _c("path", {
                    attrs: {
                      fill: "#fff",
                      d: "M348.92,395.68h-2.24a.22.22,0,0,1-.21-.26,1.34,1.34,0,0,1,2.67,0,.22.22,0,0,1-.22.25Zm-1.07-3a3.49,3.49,0,0,0-3.58,3.76,3.43,3.43,0,0,0,3.54,3.77,4.55,4.55,0,0,0,2.38-.59.81.81,0,0,0,.48-.74.79.79,0,0,0-.79-.79.69.69,0,0,0-.38.09,3.26,3.26,0,0,1-1.38.33,1.56,1.56,0,0,1-1.66-1.24.23.23,0,0,1,.22-.28h4.25a.23.23,0,0,0,.23-.21c0-.15,0-.36,0-.56a3.26,3.26,0,0,0-3.32-3.54Z",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("g", { attrs: { opacity: "0.75" } }, [
                  _c("path", {
                    attrs: {
                      fill: "#fff",
                      d: "M355.88,398.31c-.92,0-1.55-.76-1.55-1.88s.63-1.88,1.55-1.88,1.56.77,1.56,1.88-.63,1.88-1.56,1.88Zm.63-5.61a2.67,2.67,0,0,0-2.21,1.06h0l0-.68a.24.24,0,0,0-.24-.24h-.81a1,1,0,0,0-1,1V402a.07.07,0,0,0,0,.05,1.09,1.09,0,0,0,1.07,1,1.07,1.07,0,0,0,1.07-1,.43.43,0,0,0,0-.05V399.8a.23.23,0,0,1,.38-.17,2.47,2.47,0,0,0,1.71.6c1.93,0,3.14-1.65,3.14-3.77s-1.21-3.76-3.12-3.76Z",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("g", { attrs: { opacity: "0.75" } }, [
                  _c("path", {
                    attrs: {
                      fill: "#fff",
                      d: "M362.84,393.1a.26.26,0,0,0-.26-.26h-.79A1.09,1.09,0,0,0,360.7,394v5h0a1.08,1.08,0,1,0,2.15,0,.17.17,0,0,0,0-.07V393.1Z",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("g", { attrs: { opacity: "0.75" } }, [
                  _c("path", {
                    attrs: {
                      fill: "#fff",
                      d: "M361.77,389.56a1.16,1.16,0,0,0-1.19.91,1.28,1.28,0,0,0,1.49,1.5,1.13,1.13,0,0,0,.92-1.19,1.17,1.17,0,0,0-1.22-1.22Z",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("g", { attrs: { opacity: "0.75" } }, [
                  _c("path", {
                    attrs: {
                      fill: "#fff",
                      d: "M369.82,398.21h-2.75a.24.24,0,0,1-.19-.39l2.76-3.36a1.1,1.1,0,0,0,.24-.7.9.9,0,0,0-.89-.91h-4a1,1,0,0,0-1,1.06v.48a.23.23,0,0,0,.22.24h2.48a.22.22,0,0,1,.18.37l-2.61,3.2a1.65,1.65,0,0,0-.43,1.19.67.67,0,0,0,.67.68H369a1.08,1.08,0,0,0,1.06-1.07v-.56a.23.23,0,0,0-.23-.23Z",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("g", { attrs: { opacity: "0.75" } }, [
                  _c("path", {
                    attrs: {
                      fill: "#fdc200",
                      d: "M320.54,390.25a.55.55,0,0,1-.47-.28.55.55,0,0,1,.2-.75,3.5,3.5,0,0,1,3.58,0,.57.57,0,0,1,.21.75.56.56,0,0,1-.76.21,2.3,2.3,0,0,0-1.14-.34,2.5,2.5,0,0,0-1.34.34.58.58,0,0,1-.28.07Z",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("g", { attrs: { opacity: "0.75" } }, [
                  _c("path", {
                    attrs: {
                      fill: "#fdc200",
                      d: "M319.79,388.62a.58.58,0,0,1-.47-.27.55.55,0,0,1,.19-.76,4.83,4.83,0,0,1,2.75-.72,5,5,0,0,1,2.37.72.55.55,0,0,1,.18.75.53.53,0,0,1-.75.19,3.92,3.92,0,0,0-1.85-.56,4,4,0,0,0-2.14.56.49.49,0,0,1-.28.09Z",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("g", { attrs: { opacity: "0.75" } }, [
                  _c("path", {
                    attrs: {
                      fill: "#fdc200",
                      d: "M319,386.85a.55.55,0,0,1-.29-1,6.48,6.48,0,0,1,3.61-.95,6.4,6.4,0,0,1,3.11.95.55.55,0,1,1-.57.94,5.39,5.39,0,0,0-2.57-.78,5.45,5.45,0,0,0-3,.78.48.48,0,0,1-.28.08Z",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("g", { attrs: { opacity: "0.75" } }, [
                  _c("path", {
                    attrs: {
                      fill: "#fff",
                      d: "M322.48,396.22h0a1.77,1.77,0,0,0,1.26-1.65,2.18,2.18,0,0,0-.06-.79,1.75,1.75,0,1,0-1.25,2.45Z",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("g", { attrs: { opacity: "0.75" } }, [
                  _c("path", {
                    attrs: {
                      fill: "#fff",
                      d: "M325.59,390.3A.8.8,0,0,0,325,390a.79.79,0,0,0-.78.8.82.82,0,0,0,.19.53h0a3.33,3.33,0,0,1,1,2.36h0a3.3,3.3,0,1,1-5.7-2.28.79.79,0,1,0-1.05-1.18h0l0,.05a5,5,0,0,0-1.36,3.41c0,4.75,4.66,6.14,4.89,9.17a.17.17,0,0,0,.32.09c1.8-3,4.49-5.52,4.51-9.26a4.9,4.9,0,0,0-1.31-3.36Z",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    fill: "#f7f8f9",
                    d: "M149.45,350.26c0-2.86-3.19-3.86-6.94-4.87l-2.18-.62c-5.55-1.57-11.76-3.41-11.76-11,0-7.06,6.32-11.93,14.78-11.93,7.67,0,13.33,3.31,15,8.57l-8.35,2.8c-.95-2.8-3.92-4.09-6.88-4.09-3.2,0-5.1,1.23-5.1,3.36,0,2.8,2.58,3.59,7.56,4.82l1.9.5c5.55,1.4,11.43,3.7,11.43,11.43,0,8.17-7.17,12.37-15.74,12.37-9.18,0-14.39-3.53-15.79-10.19l8.29-2.24c.89,3.3,3.41,5.15,7.78,5.15C146.88,354.29,149.45,353,149.45,350.26Z",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    fill: "#f7f8f9",
                    d: "M164.35,360.68v-38H191v8H173.25v8.62h15V347h-15v13.67Z",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    fill: "#f7f8f9",
                    d: "M219.56,360.68l-9-13.56h-5v13.56h-8.9v-38H214c6.78,0,14.39,2.57,14.39,11.7,0,6.11-3.53,9.91-9.18,11l10.58,15.24Zm-6.88-20.61c5.15,0,6.55-2.07,6.55-5,0-2.24-.9-5-6.44-5h-7.17v10.08Z",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    fill: "#f7f8f9",
                    d: "M252.55,360.68v-38h14.39c13.16,0,19.88,7.05,19.88,18.31,0,11.82-6.61,19.66-19,19.66ZM266.44,353c6.72,0,11.14-3.14,11.14-11.93,0-10.08-7.28-10.58-12.6-10.58h-3.53V353Z",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    fill: "#f7f8f9",
                    d: "M314.71,353.12H300l-2.74,7.56h-9.36l14.56-38h10l14.5,38h-9.52Zm-12.49-7.28h10.25l-5.15-13.72Z",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    fill: "#f7f8f9",
                    d: "M335.76,360.68v-30H324.23v-8h32v8H344.61v30Z",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: { fill: "#f7f8f9", d: "M361.13,360.68v-38H370v38Z" },
                }),
                _vm._v(" "),
                _c("g", { attrs: { transform: "translate(107,50)" } }, [
                  _c("path", {
                    staticStyle: { opacity: "0" },
                    attrs: {
                      id: "yellow-1",
                      fill: "#E2000F",
                      transform: "translate(0,0)",
                      d: "M121.19,65.55A4.41,4.41,0,0,1,119,57.33a29,29,0,0,1,15.49-3.86,28.64,28.64,0,0,1,13.34,3.86A4.41,4.41,0,1,1,143.39,65a19.81,19.81,0,0,0-9.22-2.67A20.05,20.05,0,0,0,123.4,65,4.39,4.39,0,0,1,121.19,65.55Z",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    staticStyle: { opacity: "0" },
                    attrs: {
                      id: "yellow-2",
                      fill: "#E2000F",
                      transform: "translate(0,0)",
                      d: "M115.15,52.54a4.41,4.41,0,0,1-2.27-8.19,40.2,40.2,0,0,1,22.07-5.68A39.76,39.76,0,0,1,154,44.35a4.41,4.41,0,0,1-4.54,7.55,30.92,30.92,0,0,0-14.83-4.42,31.39,31.39,0,0,0-17.23,4.43A4.39,4.39,0,0,1,115.15,52.54Z",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    staticStyle: { opacity: "0" },
                    attrs: {
                      id: "yellow-3",
                      fill: "#E2000F",
                      transform: "translate(0,0)",
                      d: "M108.78,38.53a4.41,4.41,0,0,1-2.27-8.19,52.38,52.38,0,0,1,54,0A4.41,4.41,0,1,1,156,37.89a43.34,43.34,0,0,0-20.78-6.19A43.88,43.88,0,0,0,111,37.9,4.39,4.39,0,0,1,108.78,38.53Z",
                    },
                  }),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.theme == "catsafe"
          ? _c(
              "svg",
              {
                staticStyle: { width: "256px", height: "256px" },
                attrs: {
                  width: "84",
                  height: "84",
                  viewBox: "0 0 84 84",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("path", {
                  staticClass: "animate-flicker animate-delay-2",
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M54 81.8369C54 81.5289 53.989 81.2209 54 80.9129C54.028 80.3709 54.227 80.1349 54.756 80.0479C55.191 79.9769 55.629 79.9699 56.058 79.9199C62.043 79.2389 66.742 76.3999 70.138 71.4399C71.903 68.8589 72.903 65.9699 73.234 62.8589C73.282 62.3609 73.338 61.8699 73.438 61.3849C73.531 60.9099 73.799 60.6989 74.286 60.6859C74.898 60.6709 75.519 60.6709 76.135 60.6869C76.629 60.7029 76.897 60.9579 76.89 61.5209C76.89 62.2409 76.841 62.9639 76.751 63.6799C76.355 66.8689 75.346 69.8499 73.655 72.5819C70.361 77.9259 65.669 81.4099 59.58 82.9359C58.191 83.2859 56.733 83.3799 55.313 83.5819C55.24 83.5959 55.167 83.5949 55.094 83.5949C54.23 83.6039 54 83.3739 54 82.5109C54 82.2849 54 82.0579 54 81.8369Z",
                    fill: "white",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  staticClass: "animate-flicker animate-delay-1",
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M54.0003 73.1689C54.0003 72.8979 53.9893 72.6279 54.0003 72.3539C54.0283 71.7009 54.2683 71.4489 54.9303 71.3769C56.0093 71.2559 57.0773 71.0579 58.0903 70.6299C61.4973 69.1869 63.6233 66.6579 64.4683 63.0629C64.5873 62.5699 64.6323 62.0619 64.6943 61.5549C64.7553 61.0259 64.9843 60.7429 65.5133 60.7099C66.1503 60.6709 66.7903 60.6709 67.4343 60.6959C67.8723 60.7119 68.1793 60.9689 68.1903 61.4309C68.2073 62.0859 68.1863 62.7549 68.0643 63.3989C67.4233 66.7649 65.7813 69.5589 63.1473 71.7469C61.3083 73.2769 59.2003 74.2789 56.8343 74.7119C56.1773 74.8369 55.5023 74.9049 54.8343 74.9499C54.3083 74.9889 54.0963 74.7869 54.0433 74.2669C54.0013 73.9029 54.0013 73.5359 53.9873 73.1689C53.9903 73.1699 53.9953 73.1689 54.0003 73.1689Z",
                    fill: "white",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M60.7236 55.4694C60.6746 55.2794 60.5026 55.1444 60.3056 55.1444L51.7546 55.1424L57.7756 45.6524C58.3016 44.8214 58.8226 43.9864 59.3436 43.1514L60.0766 41.9774C60.1596 41.8444 60.1646 41.6764 60.0886 41.5394C60.0126 41.4024 59.8686 41.3174 59.7116 41.3174H48.6756C48.5076 41.3174 48.3546 41.4154 48.2836 41.5684L48.2266 41.6934C48.1886 41.7784 48.1506 41.8624 48.1096 41.9444L38.1186 61.9194C38.0446 62.0454 37.9216 62.2564 37.9636 62.5494C37.9936 62.7624 38.1756 62.9204 38.3906 62.9204H45.8246L38.7706 79.6594C38.7086 79.8064 38.6436 79.9534 38.5786 80.0984C38.3916 80.5154 38.1986 80.9474 38.0796 81.4194C38.0346 81.5984 38.1076 81.7864 38.2636 81.8864C38.3346 81.9334 38.4166 81.9564 38.4976 81.9564C38.5926 81.9564 38.6866 81.9254 38.7656 81.8624C39.1886 81.5284 39.5086 81.1224 39.8196 80.7304C39.9276 80.5924 40.0356 80.4564 40.1486 80.3234C46.9326 72.2774 53.7106 64.2254 60.5066 56.1544C60.5836 56.0794 60.8206 55.8504 60.7236 55.4694Z",
                    fill: "white",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M71.0569 16.747C70.6809 13.258 68.2709 10.955 64.7799 10.729C57.4309 10.25 50.7649 7.757 44.8129 3.193C43.6519 2.304 42.4569 1.386 40.6809 1H39.8879H39.0699C38.9929 1 38.9169 1.008 38.8409 1.025C37.2139 1.397 35.9949 2.325 34.8169 3.224L34.6709 3.336C28.8659 7.749 22.1939 10.226 14.8409 10.699C11.2479 10.93 8.77494 13.282 8.38794 16.836C7.81594 22.081 7.87693 27.256 8.56793 32.218C11.1099 50.502 20.6369 63.973 36.8829 72.26L39.3039 66.347C28.4009 60.693 20.9539 52.196 17.1699 41.09C14.7439 33.965 13.9079 26.257 14.6849 18.176C14.6979 18.059 14.7049 17.942 14.7109 17.825C14.7189 17.702 14.7249 17.58 14.7399 17.458C14.7659 17.254 14.7979 17.162 14.8109 17.13C14.8239 17.136 14.919 17.109 15.131 17.095C24.176 16.496 32.3009 13.13 39.2809 7.606C39.4559 7.468 39.7249 7.255 39.8869 7.151V7.123C40.0469 7.214 40.3469 7.45 40.5589 7.619C47.4809 13.138 55.5389 16.242 64.5079 16.842C64.8519 16.864 64.9279 16.924 64.9279 16.924C64.9279 16.924 64.9919 16.999 65.0329 17.335C65.0499 17.461 65.0589 17.59 65.0659 17.716L65.0889 18.061C65.8669 26.19 65.0279 33.942 62.6069 41.107C61.5459 44.246 60.1969 47.177 58.5639 49.897L65.4819 49.975C68.1679 44.663 69.9699 38.712 70.8779 32.14C71.5649 27.166 71.6259 21.992 71.0569 16.747Z",
                    fill: "white",
                  },
                }),
              ]
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }